import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/header";
import { useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer/footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faEye } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";

import * as XLSX from "xlsx";

import "./organization.css";

const Settings = () => {
    const [user, setUser] = useState(null);
    const [organization, setOrganization] = useState([]);
    const [users, setUsers] = useState([]); // For Privilege List
    const [loadingOrg, setLoadingOrg] = useState(true);
    const [loadingUsers, setLoadingUsers] = useState(true);
    const [policies, setPolicies] = useState([]);
    const [loadingPolicies, setLoadingPolicies] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [fileName, setFileName] = useState("");
    const [selectedOrgId, setSelectedOrgId] = useState(null);
    const [employeeList, setEmployeeList] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const routerLocation = useLocation();  // ✅ hook at top
    const org = routerLocation.state?.org;
    const orgId = selectedOrgId || org?.org_id;

    const navigate = useNavigate();

    // Navigate to Set Privileges page
    const handleSetPrivileges = () => {
        navigate("/set-privilages");
    };

    // Fetch user data from local storage
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
            } catch (e) {
                console.error("Error parsing user data:", e);
            }
        }
    }, []);

    const getSelectedOrgId = () => {
        // prefer in-memory state if available, otherwise fallback to localStorage
        const idFromStorage = localStorage.getItem("selectedOrgId");
        return idFromStorage ? idFromStorage : null;
    };

    useEffect(() => {
        const stored = localStorage.getItem("selectedOrgId");
        if (stored) setSelectedOrgId(stored);
    }, []);

    const fetchOrganizations = async () => {
        try {
            let user = JSON.parse(localStorage.getItem("user"));
            if (!user || !user.org_id) {
                console.error("User org_id missing!");
                setOrganizations([]);
                return;
            }

            // Fetch ALL orgs from backend
            const res = await fetch("/api/org");
            const data = await res.json();

            if (Array.isArray(data)) {
                // Filter only the logged user's org_id
                const filtered = data.filter((org) => org.org_id === user.org_id);

                setOrganizations(filtered);
            } else {
                console.error("Unexpected response:", data);
                setOrganizations([]);
            }
        } catch (err) {
            console.error("Error fetching organizations:", err);
        } finally {
            setLoadingOrg(false);
        }
    };

    useEffect(() => {
        fetchOrganizations();
    }, []);


    // Fetch Users for Privilege List
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const storedUser = JSON.parse(localStorage.getItem("user"));

                if (!storedUser || !storedUser.org_id) {
                    console.error("User org_id missing!");
                    setUsers([]);
                    return;
                }

                const orgId = storedUser.org_id;

                const res = await fetch(
                    `/api/eblogin?org_id=${orgId}`
                );

                if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                }

                const data = await res.json();

                setUsers(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Error fetching users:", err);
                setUsers([]);
            } finally {
                setLoadingUsers(false);
            }
        };

        fetchUsers();
    }, []);


    const isOrgExists = organizations.length > 0;

    const handleEditOrg = (org) => {
        navigate("/orgsetup", { state: { org } });
    };

    const handleViewOrg = (org) => {
        navigate("/orgsetup", { state: { org, viewOnly: true } });
    };

    // Handle Delete User
    const handleDelete = async (userId) => {
        if (!window.confirm("Are you sure you want to delete this user?")) return;
        try {
            const res = await fetch(`/api/eblogin/${userId}`, {
                method: "DELETE",
            });
            const data = await res.json();
            if (data.success) {
                setUsers((prev) => prev.filter((u) => u.user_id !== userId));
                alert("User deleted successfully!");
            } else {
                alert("Failed to delete user.");
            }
        } catch (err) {
            console.error("Delete error:", err);
            alert("Error deleting user.");
        }
    };

    const handleOpenEmployeePopup = (orgId) => {
        if (orgId) {
            setSelectedOrgId(orgId);
            localStorage.setItem("selectedOrgId", orgId);
        } else {
            const stored = localStorage.getItem("selectedOrgId");
            if (!stored) {
                alert("Please select or save an organization first.");
                return;
            }
            setSelectedOrgId(stored);
        }
        setShowPopup(true);
    };

    const handleDownload = () => {
        window.open("/employee-template.xlsx");
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setFileName(file.name);
        const reader = new FileReader();

        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
            setEmployees(jsonData);
        };
        reader.readAsArrayBuffer(file);
    };
    const handleEdit = (user) => {
        navigate("/set-privilages", { state: { user } });
    };
    const fetchEmployeeList = async () => {
        try {
            const res = await fetch(
                `/api/organization/${orgId}/employee-summary`
            );

            const json = await res.json();
            console.log("employee-summary response =", json);

            const list =
                Array.isArray(json)
                    ? json
                    : json?.employeeSummary ||
                    json?.employees ||
                    json?.data ||
                    [];

            setEmployeeList(list);
        } catch (err) {
            console.error(err);
            setEmployeeList([]);
        }
    };

    const handleDeleteOrg = async (orgId) => {
        if (!window.confirm("Are you sure you want to delete this organization?")) return;

        try {
            const res = await fetch(`/api/org/${orgId}`, {
                method: "DELETE",
            });

            const data = await res.json();

            if (res.ok && data.success) {
                alert("✅ Organization deleted successfully");
                fetchOrganizations(); // refresh the table
            } else {
                alert("❌ Failed to delete organization");
            }
        } catch (err) {
            console.error("Error deleting organization:", err);
            alert("Error deleting organization. Check console & server logs.");
        }
    };
    const handleSaveEmployees = async () => {
        const orgIdToUse = selectedOrgId || localStorage.getItem("selectedOrgId");
        if (!orgIdToUse) {
            alert("Please select or save an organization first.");
            return;
        }

        if (!employees || employees.length === 0) {
            alert("No employees to save.");
            return;
        }

        try {
            const res = await fetch(`/api/organization/${orgIdToUse}/employees`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                // include org_id explicitly so backend doesn't depend only on URL or body missing it
                body: JSON.stringify({ org_id: orgIdToUse, employees }),
            });

            const data = await res.json();

            if (res.ok && data.success) {
                alert("✅ Employees added successfully!");
                setEmployees([]); // clear uploaded data
                setFileName("");
                setShowPopup(false);
                // refresh the table for that org
                fetchEmployeeList();
            } else {
                alert(`❌ Failed to save employees: ${data.message || JSON.stringify(data)}`);
            }
        } catch (err) {
            console.error("Error adding employees:", err);
            alert("Error adding employees. Check console for details.");
        }
    };




    return (
        <div className="settings-page">
            <aside className="sidebar">
                <Header />
            </aside>

            <main className="settings-content">
                <h3>
  Employee Details
  <span
    style={{
      color: "red",
      fontSize: "14px",
      display: "block",
      marginTop: "5px"
    }}
  >
    Note: To add an employee, you need to click on the Edit icon.
  </span>
</h3>
                <div className="grid-container">
                    {/* Organization Card */}
                    <div className="card">
                        <div className="policy-header">
                            <h2>Organization</h2>

                            {!isOrgExists && (
                                <button
                                    className="org-btn"
                                    onClick={() => navigate("/orgsetup")}
                                    title="Add new organization"
                                >
                                    Organization Settings
                                </button>
                            )}
                        </div>

                        {/* ✅ Stable container to prevent layout shift */}
                        <div className="organization-table-wrapper">
                            {loadingOrg && (
                                <div className="table-loading-overlay">
                                    <div className="spinner"></div>
                                    <p>Loading organizations...</p>
                                </div>
                            )}

                            <table className="policy-table">
                                <thead>
                                    <tr>
                                        <th>Organization Name</th>
                                        <th>Address</th>
                                        <th>Phone</th>
                                        <th>Email</th>
                                        <th>GST No</th>
                                        <th>Logo</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {organizations.length > 0 ? (
                                        organizations.map((org) => (
                                            <tr key={org.org_id}>
                                                <td>{org.org_name}</td>
                                               <td
  className="address-cell"
  style={{
    maxWidth: "500px",
    width: "500px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    wordBreak: "break-word",
    lineHeight: "22px",
    verticalAlign: "top",
  }}
>
  {org.org_address}
</td>
                                                <td>{org.org_phno || "-"}</td>
                                                <td>{org.org_email || "-"}</td>
                                                <td>{org.org_gstno || "-"}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    {org.logo ? (
                                                        <img
                                                            src={org.logo}   // 👈 already full URL, no need localhost again
                                                            alt="Logo"
                                                            width="50"
                                                            height="50"
                                                            style={{
                                                                borderRadius: "6px",
                                                                objectFit: "cover",
                                                            }}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = "/no-logo.png";
                                                            }}
                                                        />
                                                    ) : (
                                                        <div
                                                            style={{
                                                                padding: "5px 10px",
                                                                borderRadius: "6px",
                                                                backgroundColor: "#eee",
                                                                display: "inline-block",
                                                                fontWeight: "bold",
                                                                color: "#333",
                                                                fontSize: "14px",
                                                            }}
                                                            title={`Welcome ${org.org_name.split(" ")[0]}`}
                                                        >
                                                            Welcome {org.org_name.split(" ")[0]}
                                                        </div>
                                                    )}
                                                </td>



                                                <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                                    <FontAwesomeIcon
                                                        icon={faEye}
                                                        style={{ color: "#000", cursor: "pointer", marginRight: "8px" }}
                                                        title="View"
                                                        onClick={() => handleViewOrg(org)}
                                                    />
                                                    <FontAwesomeIcon
                                                        icon={faEdit}
                                                        style={{ color: "#000", cursor: "pointer", marginRight: "8px" }}
                                                        title="Edit"
                                                        onClick={() => handleEditOrg(org)}
                                                    />
                                                    
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        !loadingOrg && (
                                            <tr>
                                                <td colSpan="7">No organizations found.</td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>


                    </div>
                    {showPopup && (
                        <div className="employee-popup-overlay">
                            <div className="employee-popup-container">
                                <div className="employee-popup-header">
                                    <h3>Upload Employee Master Data</h3>
                                    <span onClick={() => setShowPopup(false)}>&#10005;</span>
                                </div>

                                <p>Download the template, fill employee details, and upload the Excel file.</p>

                                <div>
                                    <button onClick={handleDownload}>Download Template</button>
                                    <label>
                                        Upload Excel
                                        <input type="file" accept=".xls,.xlsx" onChange={handleFileUpload} hidden />
                                    </label>
                                </div>

                                {fileName && <p>Uploaded: {fileName}</p>}

                                <div>
                                    <button
                                        disabled={!employees || employees.length === 0}
                                        onClick={handleSaveEmployees}
                                    >
                                        Done
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Privilege List Card */}
                    {isOrgExists && (
                        <div className="card">
                            <div className="policy-header">
                                <h2>Privilege List</h2>
                                <button className="privilege-btn" onClick={handleSetPrivileges}>
                                    Set Privileges
                                </button>
                            </div>

                            <table className="policy-table">
                                <thead>
                                    <tr>
                                        <th>EMP ID</th>
                                        <th>User Name</th>
                                        <th>User Email</th>
                                        <th>Role</th>
                                        {/* <th>Privilege Name</th> */}
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loadingUsers ? (
                                        <tr>
                                            <td colSpan="6">Loading...</td>
                                        </tr>
                                    ) : users.length > 0 ? (
                                        users.map((user) => (
                                            <tr key={user.user_id}>
                                                <td>{user.emp_id}</td>
                                                <td>{user.user_name}</td>
                                                <td>{user.user_email_id}</td>
                                                <td>{user.role}</td>
                                                {/* <td>{user.privilege_name}</td> */}
                                                <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                                                    <FontAwesomeIcon
                                                        icon={faEdit}
                                                        style={{ color: "#000", cursor: "pointer", marginRight: "8px" }}
                                                        title="Edit"
                                                        onClick={() => handleEdit(user)}
                                                    />
                                                    <FontAwesomeIcon
                                                        icon={faTrash}
                                                        style={{ color: "#000", cursor: "pointer" }}
                                                        title="Delete"
                                                        onClick={() => handleDelete(user.user_id)}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6">No users found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
                <Footer />
            </main>
        </div>
    );
};

export default Settings;
